import React, {Component} from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download';
import LoadingSpinner from 'js/components/loading_spinner';

/**
 * @typedef AnalyticsArguments
 * @type {object}
 * @param {object} dimensions
 * @param {Array<string | number>} dimensions.brand_ids
 * @param {Array<string | number>} campaign_ids
 */

export class DistributionMetricsDownloadButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isTransmitting: false,
            didError: false
        };
    }

    setStateP = (nextState) => {
        return new Promise((resolve) => {
            this.setState(nextState, resolve);
        });
    };

    downloadCsv = async () => {
        await this.setStateP({isTransmitting: true});

        try {
            const {data} = await axios.post(
                '/analytics/distribution_metrics_csv',
                {
                    dimensions: this.props.dimensions
                },
                {
                    responseType: 'blob'
                }
            );

            fileDownload(data, 'report.csv');

            await this.setStateP({isTransmitting: false});
        } catch (error) {
            await this.setStateP({didError: true, isTransmitting: false});
        }
    };

    render() {
        const {className} = this.props;

        if (this.state.isTransmitting) {
            return (
                <button style={this.props.style} disabled className={className || 'btn btn-info'}>
                    {this.props.children} <LoadingSpinner />
                </button>
            );
        }

        return (
            <button
                style={this.props.style}
                onClick={this.downloadCsv}
                className={className || 'btn btn-info'}
            >
                {this.props.children}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./distribution_metrics_download_button.js